/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/image/css/image';
import '../../../atoms/link/css/link';
import '../../../atoms/badge/css/badge';
import './avatar.scss';
import './modifiers/small.scss';
import './modifiers/medium.scss';
import './modifiers/large.scss';
import './modifiers/link.scss';
import './modifiers/x-large.scss';
